// src/routes/domains/agency/index.ts
import { agencyRoutes } from './agency.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for Agency routes.
 * Enables code splitting: the Agency routes chunk will only load when needed.
 */
export const loadAgencyRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(agencyRoutes);
};